import { render, staticRenderFns } from "./ComixDetail.vue?vue&type=template&id=d7dc69a0&scoped=true&"
import script from "./ComixDetail.vue?vue&type=script&lang=js&"
export * from "./ComixDetail.vue?vue&type=script&lang=js&"
import style0 from "./ComixDetail.vue?vue&type=style&index=0&id=d7dc69a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7dc69a0",
  null
  
)

export default component.exports